import BuySection from 'components/BuySection/BuySection.vue'

export default {
    name: "ProductDetail",
    components: {BuySection},
    props: {
        isSoldOut: {
            type: Boolean,
            required: true
        }
    },

    setup(props) {

        return {
            isSoldOut: props.isSoldOut
        }
    }
}